import type { VideoModelConfig } from '../../types';

/** Hailuo 02 */
export const hailuo02: VideoModelConfig = {
  id: '01K5THTB4CDG3D0E26BZR6P1VC',
  displayName: 'Hailuo 02',
  defaults: {
    resolution: '768P',
    duration: 5,
  },
  resolutionOptions: [
    { label: '512P', value: '512P' },
    { label: '768P', value: '768P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'options', options: [5, 10] },
  capabilities: {},
  limits: {
    maxRefImages: 1,
  },
};
